<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
import chartResize from "./mixins/chart-resize";

export default {
  name: "linechart2",
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    chartData: {
      type: Object,
      required: true,
    },
    xAxisName: {
      type: String,
      default: "",
    },
    yAxisName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: { trigger: "axis" },
        title: {
          show: false,
          text: "客流趋势",
          textStyle: {
            align: "center",
            color: "#41A1E4",
            fontSize: 16,
          },
          top: "5%",
          left: "center",
        },
        grid: {
          left: "5%",
          right: "10%",
          top: "15%",
          bottom: "5%",
          containLabel: true,
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            name: this.xAxisName,
            nameTextStyle: {
              color: "#9ab9ca",
              //fontSize: 12
            },
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#18396E",
              },
            },
            axisLabel: {
              textStyle: {
                //fontSize: 12,
                color: "#9ab9ca",
              },
            },
            data: this.chartData.days,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: this.yAxisName,
            nameTextStyle: {
              color: "#9ab9ca",
              //fontSize: 12,
              //align: "left",
              padding: 0,
            },
            axisLine: {
              lineStyle: {
                color: "#18396E",
              },
            },
            axisLabel: {
              textStyle: {
                //fontSize: 12,
                color: "#9ab9ca",
              },
            },
            splitLine: {
              show: false,
            },
            minInterval: 1,
          },
        ],
        series: [
          {
            name: "实时客流",
            type: "line",
            smooth: true,
            symbol: "none",
            interval: true,
            itemStyle: {
              normal: {
                areaStyle: {
                  opacity: 0.2,
                  color: "#2CC8FF",
                },
              },
            },
            markPoint: {
              symbol: "circle",
              symbolSize: 5,
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    fontSize: 1,
                    color: "#2CC8FF",
                  },
                },
              },
              data: [
                {
                  type: "max",
                  name: "最大值",
                },
              ],
            },
            lineStyle: {
              normal: {
                width: 1,
              },
            },
            color: ["#2CC8FF"],
            data: this.chartData.data,
          },
        ],
      });
    },
  },
};
</script>
